import TabsPage from '../TabsPage';

import ButtonIcon from 'components/ButtonIcon';
import Button from 'components/Button';
import ButtonIconSelect from 'components/ButtonIconSelect';
import ButtonComponentSelect from 'components/ButtonComponentSelect';
import Calendar from "../../../../components/Calendar";
import ContentBlock from 'components/ContentBlock';
import Table from 'components/Table';

import { ReactComponent as PermissionYesIcon } from 'icons/components/permissionYes.svg';
import { ReactComponent as PermissionNoIcon } from 'icons/components/permissionNo.svg';

import './index.less';
import './themes/default.less';

export default class TreatmentPlan extends TabsPage {
    constructor(props) {
        super(props);

        const { planId } = this._helper.getUrlOptions();
        const clientPlanId = globalThis.savedProps.clientPlanId;
        const planIdValue = planId || clientPlanId;

        if (planId)
            globalThis.savedProps.clientPlanId = planId;
        else if (clientPlanId)
            this.needSetPageProps = true;

        const plan = planIdValue ? { id: parseInt(planIdValue) } : null;

        this.state = {
            ...this.state,
            absol: false,
            plan,
            items: [],
            presentation: [],
            showedMessage: false,
        };

        const { treatmentType, treatmentWorkStatus } = this._config;

        this.tableMap = {
            openIcon: {
                type: "icon",
                name: "arrowDown",
                hideLabel: true,
                cantSort: true,
                size: "32px",
                click: this.openStageDetailDialog.bind(this)
            },
            title: {
                label: "treatmentPlan.stageName",
                type: "rows",
                rows: ["title",
                    { key: "activityDate", style: "second", type: "date", tooltip: "client.durationTreatmentPhase" },
                    { key: "type", translate: true, store: treatmentType, nameKey: "name", type: "select", style: "blue", }
                ],
            },
            teeth: {
                label: "client.teeth",
                type: "teeth",
                style: "link hand",
                onClick: this.props.changeTab.bind(this, "treatment", {})
            },
            statusInfo: {
                label: "main.status",
                type: "rows",
                rows: [
                    {
                        key: "workStatus",
                        label: "treatmentPlan.treatmentStatus",
                        style: "link hand",
                        type: "select",
                        nameKey: "name",
                        translate: true,
                        store: treatmentWorkStatus,
                        onClick: this.openStatusDialog.bind(this)
                    },
                    {
                        key: "duration",
                        label: "treatmentPlan.visitsNumber",
                        style: "link hand",
                        callback: this._helper.formatNumberText.bind(this._helper, "client.visit", "client.visita", "client.visitov"),
                        onClick: this.openPinVisitDialog.bind(this)
                    },
                ],
            },
            agreed: {
                label: "client.agreedWithPatient",
                callback: this.cellAgreed.bind(this)
            },
            intendedTreatmentDate: {
                label: "client.recomTreatmentDate",
                callback: this.cellTreatmentDate.bind(this)
            },
            /*agreedWithPatient
            treatmentDirectionId: {
                label: "treatmentPlan.treatmentDir",
                type: "select",
                nameKey: "name",
                translate: true,
                store: treatmentDirection,
            },
            */
            doctorId: {
                label: "client.doctor",
                type: "doctor",
            },
            preSecuredInvoice: {
                label: "treatmentPlan.provisionalBill",
                style: "link hand",
                callback: this.provisionalBillCell.bind(this),
                onClick: this.changeTab.bind(this, "preliminary")
            },
            invoices: {
                label: "main.payment",
                style: "link hand",
                callback: this.paidSumCell.bind(this),
                onClick: this.changeTab.bind(this, "forPayment")
            },
            notes: {
                label: "client.note",
            },
            actions: {
                type: "actions",
                items: [
                    { name: "main.edit", onClick: this.editStage.bind(this) },
                    { name: "treatmentPlan.attachPayment", onClick: this.props.changeTab.bind(null, "invoices", { subTab: "forPayment" }) },
                    { line: true },
                    { name: "client.createDiary", onClick: this.props.changeTab.bind(null, "treatment", {}) },
                    { name: "client.attachDiary", onClick: null },
                    { name: "treatmentPlan.createVisit", onClick: this.goToAppointment.bind(this) },
                    { name: "treatmentPlan.pinVisit", onClick: this.openPinVisitDialog.bind(this) },
                    { line: true },
                    { name: "client.delete", onClick: this.deleteStageConfirm.bind(this) },
                ],
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.tableMapPresentation = {
            createdTime: {
                label: "Дата загрузки",
                type: "dateTime",
            },
            fileName: {
                label: "Имя файла",
                size: "200px"
            },
            comment: {
                label: "Описание",
            },
            actions2: {
                label: "main.actions",
                callback: this.renderDownloadCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
            actions: {
                type: "actions",
                items: [
                    { name: "main.edit", onClick: this.onChangeNotes.bind(this) },
                    { name: "client.delete", onClick: this.deleteDocument.bind(this) },
                ],
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.useTooltip = true;
        this.savedScrollPosition = null;
    }

    componentDidMount() {
        this.refresh();
    }

    componentDidUpdate() {
        const { plan, items, showedMessage } = this.state;

        if (!plan && items.length && !items[0].published && !showedMessage) {
            this._helper.confirm({ title: "Предупреждение", message: this.tr("Не забудьте опубликовать план лечения") }, null);
        }

        this.state.showedMessage = true;

        super.componentDidUpdate();
        if (this.treatTable?.domNode && this.savedScrollPosition !== null) {
            this.treatTable.domNode.scrollTop = this.savedScrollPosition;
            this.savedScrollPosition = null;
        }
    }

    async deleteDocument({ uuid4 }) {
        this._helper.showLoading();
        await this._request.files.deletep(uuid4);
        this._helper.hideLoading();
        this.refresh();
    }

    async downloadDocument(imageUrl, imageName) {
        this._helper.showLoading();
        await this._request.files.downloadDocument(imageUrl, imageName);
        this._helper.hideLoading();
    }

    async updateComment(comment, id) {
        this._helper.showLoading();
        await this._request.fileStorage.update(id, comment);
        this._helper.hideLoading();
        this.refresh();
    }

    onChangeNotes(info) {
        this._helper.openDialog("changeNote", info, this.updateComment.bind(this));
    }

    renderDownloadCell(value, map, { source, fileName }) {
        return <ButtonIcon name="download" onClick={this.downloadDocument.bind(this, source, fileName)} />;
    }

    cellTreatmentDate(value, map, { id }) {
        if (value) {
            const content = (onClose) => {

                return (
                    <div className="calendar flex col">
                        <Calendar
                            ref={el => this.calendar = el}
                            defaultValue={new Date(value)}
                            interval={1}
                        />
                        <div className="flex end">
                            <div className="flex gap16">
                                <Button
                                    label="main.cancel"
                                    size="small"
                                    type="transparent"
                                    onClick={() => onClose()}
                                />
                                <Button
                                    label={"Сохранить"}
                                    size="small"
                                    onClick={this.changeDate.bind(this, id, onClose)}
                                />
                            </div>
                        </div>

                    </div>
                );
            };

            const items = [
                { content },
            ];

            const text = this._helper.date.toStr(new Date(value), "DD.MM.YYYY");
            const comp = (<div className="hand" style={{ padding: "6px" }}>{text}</div>);

            return <ButtonComponentSelect component={comp} items={items} />;
        }

        return false;
    }

    cellAgreed(value, map, info) {
        const { id } = info;
        const content = (onClose) => (
            <div className="flex col">
                <div className="wrapIcon flex gap8 hand" onClick={this.onAnswerSelect.bind(this, false, id, onClose)}>
                    <PermissionNoIcon />
                    <div>{this.tr("client.no")}</div>
                </div>
                <div className="wrapIcon flex gap8 hand" onClick={this.onAnswerSelect.bind(this, true, id, onClose)}>
                    <PermissionYesIcon />
                    <div>{this.tr("client.yes")}</div>
                </div>
            </div>
        );

        const items = [
            { content },
        ];

        const comp = (<div className="flex gap8 hand" style={{ padding: "6px" }}>
            {value ? <><div style={{ width: "16px" }}><PermissionYesIcon /></div> <div>{this.tr("client.yes")}</div></> :
                <><div style={{ width: "16px" }}><PermissionNoIcon /></div> <div>{this.tr("client.no")}</div></>}
        </div>);

        return <ButtonComponentSelect component={comp} items={items} />;
    }

    onAnswerSelect(agreed, visitId, onClose) {
        onClose();
        this.changeAnswer(visitId, agreed);
    }

    async changeDate(visitId, onClose) {
        const intendedTreatmentDate = this._helper.date.toStr(this.calendar.value, 'YYYY-MM-DD');
        onClose();
        if (visitId) {
            this._helper.showLoading();
            await this._request.treatmentTasks.update(visitId, { intendedTreatmentDate });
            this._helper.hideLoading();

            this.refresh();
        }
    }

    async changeAnswer(visitId, agreed) {
        if (visitId) {
            this._helper.showLoading();
            await this._request.treatmentTasks.update(visitId, { agreed });
            this._helper.hideLoading();

            this.refresh();
        }
    }

    changeTab(subTab, info) {
        const { id: invoiceId } = info.preSecuredInvoice;
        globalThis.invoicesTempScrollId = invoiceId;
        this.props.changeTab("invoices", { subTab });
    }

    provisionalBillCell(val, props, info) {
        const value = info.preSecuredInvoice?.totalSum || 0;
        const { id, createdTime } = (val || {});
        const date = this._helper.date.toDateStr(createdTime, "dd.mm.yyyy");
        const tooltip = `Предварительный счет № ${id} от ${date}`;

        return <div data-tooltip={tooltip}>{this._helper.number.toSum(value)}</div>;
    }

    paidSumCell(val, props, info) {
        const value = info.preSecuredInvoice?.invoicesPaidSum || 0;
        let tooltip = `Счет не выставлен`;
        if (val && val.length) {
            tooltip = ``;
            val.forEach(it => {
                const { id, createdTime, totalSum, paidSum } = it;
                const date = this._helper.date.toDateStr(createdTime, "dd.mm.yyyy");
                tooltip += ` № ${id} от ${date} на сумму ${totalSum} оплачено ${paidSum} руб. `;
            });
        }
        return <div data-tooltip={tooltip} data-tooltip-max-width={340}>{this._helper.number.toSum(value)}</div>;
    }

    goToAppointment(info) {
        const { domainId, id: stageId } = info;
        const { id, fname, lname, sname, birthday, phoneNumber, photoUid } = this.props.info;
        const items = [{ id, fname, lname, sname, birthday, phoneNumber, photoUid }];
        const dateI = this._helper.date.toStr();
        this._helper.storage("apptSelectedClients", { items, date: dateI });
        this._helper.storage("apptLastActiveClient", id);
        this._helper.openPage("appointment", { dateI, domainId, stageId, forClientId: id });
    }

    openPinVisitDialog(info) {
        this._helper.openDialog("pinVisits", info, this.pinVisits.bind(this));
    }

    openStatusDialog(info) {
        this._helper.openDialog("status", info, this.changeStatus.bind(this));
    }

    editStage(info) {
        info.clientId = this.props.info.id;

        this._helper.openRightPopup("planStageAddEdit", info, this.addEditStage.bind(this));
    }

    selectPlan(info) {
        this.setPlanLink(info);
        this.refresh();
        this.changeState("plan", info);
        this.state.showedMessage = false;
    }

    setPlanLink(info) {
        const planId = info?.id;
        this.props.setPageTab(null, info?.id ? { planId } : 0);
        globalThis.savedProps.clientPlanId = planId;
    }

    async refresh() {
        this._helper.showLoading();
        this.savedScrollPosition = this.treatTable?.domNode?.scrollTop || 0;

        const { id } = this.props.info;

        const invoicesResp = await this._request.invoices.getAllForClient(id);
        const invoices = invoicesResp?.data || [];

        const resp = await this._request.treatmentPlans.getForClient(id);
        //const filterCanceled = true;
        //const resp = await this._request.visits.getForPlanClient(id, filterCanceled);
        const items = (resp?.data || []);

        const respFile = await this._request.fileStorage.getPresentationClient(id);
        const presentation = (respFile?.data || []);

        let plan = null;
        if (this.state.plan?.id)
            plan = items.find(it => it.id === this.state.plan.id);

        if (plan?.treatmentTasks?.length > 0) {
            plan.treatmentTasks = JSON.parse(JSON.stringify(plan.treatmentTasks.sort((a, b) => a.sortIndex - b.sortIndex)));
            plan.treatmentTasks = plan.treatmentTasks.map(it => {
                it.invoices = [];
                if (it.preSecuredInvoice)
                    it.invoices = invoices.filter(inv => inv.parentInvoiceId === it.preSecuredInvoice.id);
                return it;
            });
        }

        this.setPlanLink(plan);
        this.setState({ items, plan, presentation });

        if (this.treatTable?.domNode)
            this.treatTable.domNode.scrollTop = this.savedScrollPosition;

        this._helper.hideLoading();
    }

    async addEdit(info) {
        this.updateInfo(info);
    }

    async updateInfo(data) {
        const info = this.props.getAddEditProps(data);

        if (!info.id) {
            info.published = false;
            info.refusing = false;
            info.refusingComment = "";
        }

        this._helper.showLoading();
        await this._request.treatmentPlans.addUpdate(info);
        this._helper.hideLoading();

        this.refresh();
    }

    deleteConfirm(id) {
        this._helper.confirm({ title: "client.deleteTreatment", message: this.tr("client.deleteTreatmentConfirm") }, this.delete.bind(this, id));
    }

    async delete(id) {
        this._helper.showLoading();

        await this._request.treatmentPlans.delete(id);

        this._helper.hideLoading();

        this.refresh();
    }

    async refuseTrat(id, refusingComment, refusing) {
        await this.updateInfo({
            id,
            refusing,
            refusingComment,
        });
    }

    async publish(id, published) {
        await this.updateInfo({ id, published });
    }

    async copy(id, info) {
        await this._request.treatmentPlans.copy(id, info);

        this.refresh();
    }

    async addEditStage(data) {
        const info = this.props.getAddEditProps(data);

        if (!info.id) {
            info.status = "ACTIVE";
            info.treatmentPlanId = this.state.plan.id;
            info.domainId = this.props.clinicId;
        }

        this._helper.showLoading();

        await this._request.treatmentTasks.addUpdate(info);

        this._helper.hideLoading();

        this.refresh();
    }

    deleteStageConfirm(info) {
        this._helper.confirm({ title: "client.deleteStage", message: this.tr("client.deleteStageConfirm") }, this.deleteStage.bind(this, info));
    }

    async deleteStage(info) {
        this._helper.showLoading();
        await this._request.treatmentTasks.delete(info?.id);
        this._helper.hideLoading();

        this.refresh();
    }

    async onStageIndexChange(info, sortIndex) {
        const { treatmentTasks } = this.state.plan;
        // Создаем новый массив, а не мутируем существующий
        const treatmentTasksSort = this._helper.array.changePositionByIdByPos([...treatmentTasks], info.id, sortIndex);

        const obj = treatmentTasksSort.reduce((acc, it, i) => {
            acc[it.id] = {
                sortIndex: i
            };
            return acc;
        }, {});
        //this._helper.showLoading();
        await this._request.treatmentTasks.updateSort(obj);
        // Обновляем состояние после завершения запроса

        this.refresh();
        //this._helper.hideLoading();
        //window.location.reload();
    }

    async pinVisits(visitId, planId) {

        if (visitId && planId) {
            this._helper.showLoading();
            await this._request.visits.update(visitId, {
                treatmentTaskId: planId
            });
            this._helper.hideLoading();

            this.refresh();
        }
    }

    async changeStatus(visitId, workStatus) {
        if (visitId && workStatus) {
            const { plan } = this.state;

            await this._request.treatmentTasks.update(visitId, { workStatus });
            this._helper.hideLoading();

            await this.refresh();
            if (workStatus === 7 && !this.props.info.statusTreatment &&
                plan?.treatmentTasks.filter(it => visitId !== it.id).every(it => it.workStatus === 7)) {
                this.props.updateClient({ statusTreatment: "sanitized" });
                this._helper.showNotifyPopup({
                    type: "success",
                    label: "Смена статуса у пациента",
                    text: this.tr("Статус лечения сменился на санирован")
                });
            }
        }
    }

    openStageDetailDialog(info) {
        this._helper.openDialog("treatmentPlanDetail", info);
    }

    formTitle(title, published, withGap, clickCb) {
        const state = published ? "published" : "notPublished";
        const cl = published ? " active" : "";
        const gap = withGap ? " gap4" : "";

        return (
            <div className={"flex1 flex col hand" + gap} onClick={withGap ? clickCb : null}>
                <div className="text blockTitle">
                    {this.tr(title)}
                </div>
                <div className={"blockState text p2" + cl}>{this.tr("treatmentPlan", state)}</div>
            </div>
        );
    }

    insertPlan(i, info, openDialog) {
        const { id, title, published, refusing, refusingComment, createdTime, doctorId, treatmentTasks } = info;
        const doctor = this.props.getDoctorById(doctorId);

        const date = createdTime ? this._helper.date.toDateStr(createdTime) : "-";
        const doc = doctor?.id ? this._helper.string.formatFullName(doctor) : "-";

        let itemsDur = 0;
        let cost = 0;
        let paid = 0;

        const items = (treatmentTasks || []);
        const l = items.length;

        items.forEach(({ duration, preSecuredInvoice }) => {
            itemsDur += duration;
            cost += (preSecuredInvoice?.totalSum || 0);
            paid += (preSecuredInvoice?.invoicesPaidSum || 0);
        });

        const canPusblish = l > 0;
        const count = l > 0 ? parseInt(itemsDur, 10) : this.tr("main.notIndicated");
        const pubLabel = published ? "treatmentPlan.removePubl" : "treatmentPlan.publish";
        const tratLabel = refusing ? "treatmentPlan.resume" : "treatmentPlan.refuse";
        const tratCb = refusing ? this.refuseTrat.bind(this, id, "", false) : openDialog.bind(this, "refuseTratPlan", info, this.refuseTrat.bind(this));

        const actions = [
            { name: "main.edit", onClick: openDialog.bind(this, "addTratPlan", this.props.info, info, this.addEdit.bind(this)) },
            { name: "main.createCopy", onClick: openDialog.bind(this, "copyTratPlan", info, this.copy.bind(this)) },
            { line: true },
            { name: tratLabel, onClick: tratCb },
            { name: "client.delete", onClick: this.deleteConfirm.bind(this, id) },
        ];

        if (canPusblish)
            actions.unshift({ name: pubLabel, onClick: this.publish.bind(this, id, !published) });

        const clickCb = this.selectPlan.bind(this, info);

        return (
            <ContentBlock
                key={i}
                itemStyle="flex1"
                title={this.formTitle(title, published, true, clickCb)}
                icon={{
                    translate: true,
                    items: actions
                }}
            >
                <div className="content flex col gap16 hand" onClick={clickCb}>
                    {this.renderRow("client.date", date)}
                    {this.renderRow("treatmentPlan.numberRecepts", count)}
                    {this.renderRow("client.doctor", doc)}
                    {this.renderRow("treatmentPlan.cost", this._helper.number.toSum(cost))}
                    {this.renderRow("main.payment", this._helper.number.toSum(paid))}
                    {!!refusing && !!refusingComment && (
                        this.renderRow("app.cancelReason", refusingComment)
                    )}
                </div>
            </ContentBlock>
        );
    }

    renderPlans() {
        const { openDialog } = this.props;
        const { items, presentation } = this.state;

        const info = {
            infoFile: {
                domainId: this.props.clinicId,
                domain: "presentation",
                type: "DOCUMENT",
                clientId: this.props.info.id,
            },
            title: "Загрузка файла"
        };

        const addCb = openDialog.bind(this, "addTratPlan", this.props.info, null, this.addEdit.bind(this));
        const addFile = openDialog.bind(this, "fileUpload", info, this.refresh.bind(this));

        return (
            <div className="flex1 flex col gap16">
                <div className="flex">
                    <div className="titleBlock text blockTitle">
                        {this.tr("treatmentPlan.plans")}
                    </div>
                </div>
                <div className="flex flex1 gap16">
                    {/*items.map((it, i) => this.insertPlan(i, it, openDialog))*/}
                    <div className="flex1">
                        {items?.length === 1 ? this.insertPlan(1, items[0], openDialog) :
                            items?.length > 1 ? <div className="flex col gap8">{items.map((it, i) => (this.insertPlan(i, it, openDialog)))}</div> : false}
                        {items?.length < 1 && <ContentBlock
                            title="treatmentPlan.new"
                            icon={{ name: "plus", onClick: addCb }}
                            border="dashed"
                        ></ContentBlock>}
                    </div>

                    <div className="flex1">
                        <div className="wrapPresent rad8">
                            <div className="wrapHeader flex centerV between">
                                <div className="text blockTitle">{"Загруженные презентации"}</div>
                                <ButtonIcon name="plus" onClick={addFile} />
                            </div>
                            <div>
                                <div className="presHeader flex black3 text p1">
                                    <div className="cellPres flex1 centerH">{"Дата загрузки"}</div>
                                    <div className="cellPres flex1">{"Имя файла"}</div>
                                    <div className="cellPres flex1">{"Описание"}</div>
                                    <div className="colAction"></div>
                                    <div className="colAction"></div>
                                </div>
                                {presentation?.map((it, i) => (<div key={"rowPresent" + i} className="rowPresent flex text p1">
                                    <div className="cellPres flex1 flex centerV ">{this._helper.date.toStr(this._helper.date.toLocal(it.createdTime), "DD.MM.YYYY HH:mm")}</div>
                                    <div className="cellPres flex1 flex centerV ">{it.fileName}</div>
                                    <div className="cellPres flex1 flex centerV ">{it.comment}</div>
                                    <div className="colAction">
                                        <ButtonIcon name="download" onClick={this.downloadDocument.bind(this, it.source, it.fileName)} />
                                    </div>
                                    <div className="colAction">
                                        <ButtonIconSelect
                                            name="dots"
                                            translate={true}
                                            stopEvent={true}
                                            items={[
                                                { name: "main.edit", onClick: this.onChangeNotes.bind(this, it) },
                                                { name: "client.delete", onClick: this.deleteDocument.bind(this, it) },
                                            ]}
                                        />
                                    </div>
                                </div>))}
                            </div>
                        </div>

                        {/*<div className="wrapHeader flex centerV between">
                            <div className="text blockTitle">{"Загруженные презентации"}</div>
                            <ButtonIcon name="plus" onClick={addFile} />
                        </div>*/}
                        {/*<Table
                            map={this.tableMapPresentation}
                            items={presentation}
                        />*/}
                    </div>

                </div>
                <div className="flex gap16">

                    {/*<ContentBlock
                        itemStyle="flex1"
                        title="Загруженные презентации"
                        icon={{
                            name: "plus",
                            onClick: addFile
                        }}
                    >
                        <div className="flex1 flex" style={{ minHeight: "300px" }}>
                            <Table
                                map={this.tableMapPresentation}
                                items={presentation}
                            />
                        </div>
                    </ContentBlock>*/}
                </div>
            </div>
        );
    }

    print(clientId, id, treatmentTasks) {
        this.printShow("Treatment_plan", { clientId, planId: id + "", clinicId: this.props.clinicId });

        /*const clinics = this._helper.getClinics();
        const clinic = clinics.find(infoClinic => infoClinic.id === this.props.clinicId);
        const { profileNumber, birthday, doctorId } = this.props.info;
        const fio = this._helper.string.formatFullName(this.props.info);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));

        const printInfo = {
            clinic,
            profileNumber,
            birthday,
            fio,
            doctor,
            treatmentTasks
        };

        this._print.treatmentPlan(printInfo);*/
    }

    renderStages(info) {
        const { openRightPopup } = this._helper;
        const { title, published, clientId, id, treatmentTasks } = info;
        const tt = treatmentTasks ? JSON.parse(JSON.stringify(treatmentTasks)) : [];

        return (
            <>
                <div className="flex between centerV">
                    <div className="flex centerV gap16 hand" onClick={this.selectPlan.bind(this, null)}>
                        <ButtonIcon
                            name="arrowLeft"
                            tooltip="main.back"
                        />
                        {this.formTitle(title, published, false)}
                    </div>
                    <div className="flex gap16">
                        <ButtonIcon
                            name="print"
                            tooltip="main.print"
                            onClick={this.print.bind(this, clientId, id, tt)}
                        />
                        <ButtonIcon
                            name="plus"
                            tooltip="treatmentPlan.addStage"
                            onClick={openRightPopup.bind(this, "planStageAddEdit", null, this.addEditStage.bind(this))}
                        />
                    </div>
                </div>
                <Table
                    ref={(el) => this.treatTable = el}
                    map={this.tableMap}
                    items={tt}
                    useIndexes={this.onStageIndexChange.bind(this)}
                    rowProps={{ useIds: true }}
                />
            </>
        );
    }

    renderContent() {
        const { plan } = this.state;

        if (!plan)
            return this.renderPlans();

        return this.renderStages(plan);
    }
}
